
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Pour ceux qui ont peur des nouvelles technologies, celle-ci n’en est pas une!
Les virus inactivés ont été employés pour créer les vaccins contre la polio, la
rage ou encore l’hépatite A.`}</p>
    <p>{`En annonçant l'autorisation de ce produit pour une utilisation d'urgence, l'OMS
a souligné que
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news/item/07-05-2021-who-lists-additional-covid-19-vaccine-for-emergency-use-and-issues-interim-policy-recommendations"
      }}>{`ses conditions de stockage peu contraignantes`}</a>{`
le rendent parfaitement adapté là où les ressources sont limitées. "Il s’agit
également du premier vaccin comportant une pastille de contrôle, une petite
étiquette collée au flacon de chaque dose qui change de couleur si le vaccin est
exposé à la chaleur, ce qui permet à l’agent de santé concerné de savoir si la
dose peut être utilisée en toute sécurité", relève l'organisation.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;